import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useCallback } from 'react';
import styled from 'styled-components';
import { useThemeComponents } from '../../../../../themes';
import renderMarkdown from '../../../../../utilities/renderMarkdown';
import { ModalBody } from '../ui';

const Content = styled.div`
    max-height: 80vh;
    overflow: auto;
    white-space: pre-line;
`;

const StyledButton = styled(Button)`
    padding: 0;
    border: none;
    margin-left: auto;
`;

const StyledCloseOutlined = styled(CloseOutlined)`
    font-size: 1.5rem;
    color: #000;
`;

const Title = styled.div`
    font-weight: 700;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
`;

export type TermsAndConditionModalProps = {
    modalVisible: boolean;
    setModalVisible: (visible: boolean) => void;
    title: string;
    body: string;
};

const TermsAndConditionModal = ({ modalVisible, setModalVisible, title, body }: TermsAndConditionModalProps) => {
    const { Modal } = useThemeComponents();

    const onClose = useCallback(() => {
        setModalVisible(false);
    }, [setModalVisible]);

    return (
        <Modal footer={null} onCancel={onClose} open={modalVisible} width={950} centered>
            <ModalBody>
                <StyledButton icon={<StyledCloseOutlined />} onClick={onClose} />
                <Content>
                    {title && <Title>{title}</Title>}
                    {body && renderMarkdown(body)}
                </Content>
            </ModalBody>
        </Modal>
    );
};

export default TermsAndConditionModal;
